import { TrendingUp, TrendingDown } from "lucide-react";

const StatCard = ({
  label,
  value,
  trend,
  isPositive,
  color = "text-slate-900",
}) => (
  <div className="p-6 border-r border-y border-[#EEF1F3] first:border-l-0 last:border-r-0">
    <p className="text-[#7D828D] font-medium text-sm mb-2">{label}</p>
    <h2 className={`text-2xl font-medium ${color}`}>{value}</h2>
    {trend && (
      <div
        className={`flex items-center gap-1 text-sm font-medium mt-2 ${isPositive ? "text-green-500" : "text-red-500"}`}
      >
        {isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
        <span>{trend}</span>
        <span className="text-gray-400 font-medium ml-1">vs last month</span>
      </div>
    )}
  </div>
);

export default StatCard;
